import { render } from "./formField.vue?vue&type=template&id=16b619bc&scoped=true&ts=true"
import script from "./formField.vue?vue&type=script&lang=ts"
export * from "./formField.vue?vue&type=script&lang=ts"

import "./formField.vue?vue&type=style&index=0&id=16b619bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16b619bc"]])

export default __exports__